import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { listReceivingInvoices, ReceivingInvoice } from './api';
import './inventory-v2.css';
import DataTable from '../../shared/components/DataTable';

const Receiving: React.FC = () => {
  const { sessionToken, user } = useAuth();
  const [invoices, setInvoices] = useState<ReceivingInvoice[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    listReceivingInvoices(sessionToken)
      .then(res => setInvoices(res.invoices))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [sessionToken]);

  if (loading) return <div className="inv2-loading">Loading...</div>;
  if (error) return <div className="inv2-error">{error}</div>;

  return (
    <div className="inv2-page">
      <div className="inv2-header">
        <h1>📦 Receiving Invoices</h1>
        <div className="inv2-header-actions">
          {['Owner', 'Admin', 'Manager'].includes(user?.role || '') && (
            <>
              <Link to="/inventory/invoice-scan" className="inv2-btn">🔍 Scan Invoice</Link>
              <Link to="/inventory/receiving/new" className="inv2-btn inv2-btn-primary">+ New Invoice</Link>
            </>
          )}
        </div>
      </div>

      <div className="inv2-table-container">
        <DataTable
          rows={invoices}
          rowKey={(inv) => inv.id}
          caption="Received invoices"
          moreLabel="Detail"
          empty="No invoices yet"
          columns={[
            { key: 'invoice', header: 'Invoice #', priority: 'primary', render: (inv) => <Link to={`/inventory/receiving/${inv.id}`} className="inv2-link">{inv.invoice_number || `#${inv.id}`}</Link> },
            { key: 'total', header: 'Total', priority: 'summary', numeric: true, render: (inv) => (inv.total != null ? `$${Number(inv.total).toFixed(2)}` : '—') },
            { key: 'supplier', header: 'Supplier', priority: 'summary', render: (inv) => inv.supplier_name || '—' },
            { key: 'status', header: 'Status', priority: 'summary', render: (inv) => <span className={`inv2-status inv2-status-${inv.status}`}>{inv.status}</span> },
            { key: 'date', header: 'Date', priority: 'summary', render: (inv) => (inv.invoice_date ? new Date(inv.invoice_date).toLocaleDateString() : '—') },
            { key: 'lines', header: 'Lines', priority: 'detail', numeric: true, render: (inv) => inv.line_count || 0 },
            { key: 'created', header: 'Created', priority: 'detail', render: (inv) => new Date(inv.created_at).toLocaleDateString() },
          ]}
        />
      </div>
    </div>
  );
};

export default Receiving;
